import { connect } from 'react-redux';
import ReactSearchbox from './ReactSearchBox';

const mapStateToProps = ({
  content: { searchBox },
  intl: { locale },
  system: { siteName, isMobile }
}) => ({
  domain: siteName,
  site: siteName,
  locale,
  isMobile,
  ...searchBox
});

export default connect(mapStateToProps)(ReactSearchbox);



// WEBPACK FOOTER //
// ./src/universal/components/ReactSearchBox/index.js